import { render, staticRenderFns } from "./ColumnTransactionStatus.vue?vue&type=template&id=242d2368&scoped=true"
import script from "./ColumnTransactionStatus.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatus.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatus.vue?vue&type=style&index=0&id=242d2368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d2368",
  null
  
)

export default component.exports